<template lang="pug">
stacked-countdown(
  :countdown='startsIn',
  :label='label',
  :label-classes='labelClasses',
  :count-wrap-classes='countWrapClasses',
  :timeslot-classes='timeslotClasses',
  :time-count-classes='timeCountClasses',
  :time-label-classes='timeLabelClasses',
  @finished='isStarted = true'
)
</template>
<script>
import StackedCountdown from './StackedCountdown'

export default {
  data() {
    return {
      isStarted: false,
      startsIn: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      startsInInterval: null
    }
  },
  props: {
    giveaway: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: 'Starts In'
    },
    labelClasses: {
      type: String,
      required: false,
      default: ''
    },
    countWrapClasses: {
      type: String,
      required: false,
      default: ''
    },
    timeslotClasses: {
      type: String,
      required: false,
      default: ''
    },
    timeCountClasses: {
      type: String,
      required: false,
      default: ''
    },
    timeLabelClasses: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {
    isStarted() {
      if (this.isStarted) {
        this.$emit('started', this.giveaway)
        clearInterval(this.startsInInterval)
      }
    }
  },
  created() {
    this.getFormattedStartsIn()
    this.startsInInterval = setInterval(this.getFormattedStartsIn, 1000)
  },
  beforeDestroy() {
    clearInterval(this.startsInInterval)
  },
  methods: {
    getFormattedStartsIn() {
      this.startsIn = this.giveaway.counterFormattedStartsIn

      if (this.giveaway.startsIn <= 0) {
        this.isStarted = true
      }
    }
  },
  components: {
    StackedCountdown
  }
}
</script>
